// extracted by mini-css-extract-plugin
module.exports = {"swiper":"NewLists_swiper__611uK","root":"NewLists_root__lcs36"};